module.exports = __webpack_public_path__ + "static/media/loginBanner_02Top_1028.fc66c5d9.jpg";